/* eslint-disable react-refresh/only-export-components */
import cn from '@/lib/cn'
import { ReactNode } from 'react'

export enum ButtonType {
  default = 'default',
  destructive = 'destructive',
  outlined = 'outlined',
  outlinedPrimary = 'outlinedPrimary',
  primary = 'primary',
  secondary = 'secondary',
  text = 'text',
  inactive = 'inactive',
}

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonType?: ButtonType
  className?: string
  children: ReactNode
  [key: string]: unknown
}

export const btnClass: Record<ButtonType, string> = {
  [ButtonType.default]: 'btn-default',
  [ButtonType.destructive]: 'btn-destructive',
  [ButtonType.outlined]: 'btn-outlined',
  [ButtonType.outlinedPrimary]: 'btn-outlined primary',
  [ButtonType.primary]: 'btn-primary',
  [ButtonType.secondary]: 'btn-secondary',
  [ButtonType.text]: 'btn-text',
  [ButtonType.inactive]: 'btn-inactive',
}

const Button = ({
  buttonType = ButtonType.default,
  className,
  children,
  loading,
  ...rest
}: ButtonProps) => {
  const typeClasss = btnClass[buttonType]
  return (
    <button
      className={cn(
        'btn rounded-lg',
        {
          [typeClasss]: true,
        },
        className,
      )}
      {...rest}
    >
      {loading ? <span className="btn-loading-spinner" /> : children}
    </button>
  )
}

export default Button
